import { applyMiddleware, combineReducers } from "redux";
import createSagaMiddleware from "redux-saga";
import { all, fork, put } from "typed-redux-saga";
import { appActions, AppReducer, appSaga } from "./app";
import { ClientReducer } from "./client/reducers";
import { AuthReducer } from "./auth/reducers";
import { authActions, authSaga } from "./auth";
import { clientSaga } from "./client/operations";
import { dashboardSaga } from "./dashboard/operations";
import { dashboardActions } from "./dashboard";
import { DashboardReducer } from "./dashboard/reducers";
import { FeatureReducer } from "./feature/reducers";
import { featureSaga } from "./feature/operations";
import { clientActions } from "./client";
import { featureActions } from "./feature";
import { ownerSaga } from "./owner/operations";
import { OwnerReducer } from "./owner/reducers";
import { ownerActions } from "./owner/actions";
import { blogSaga } from "./blog/operations";
import { BlogReducer } from "./blog/reducers";
import { blogActions } from "./blog/actions";
import { PopularPlaceReducer } from "./popular-place/reducers";
import { popularPlaceSaga } from "./popular-place/operations";
import { popularPlaceActions } from "./popular-place/actions";
import { homepageImageSaga } from "./homepage-image/operations";
import { HomepageImageReducer } from "./homepage-image/reducers";
import { homepageImageActions } from "./homepage-image/actions";
import { memberSaga } from "./member/operations";
import { MemberReducer } from "./member/reducers";
import { memberActions } from "./member/actions";
import { PropertyReducer } from "./property/reducers";
import { propertySaga } from "./property/operations";
import { propertyActions } from "./property/actions";
import { accountSaga } from "./account/operations";
import { AccountReducer } from "./account/reducers";
import { accountActions } from "./account/actions";

const sagaMiddleware = createSagaMiddleware({});
export function runSaga() {
    sagaMiddleware.run(function* () {
        yield all([
            fork(appSaga),
            fork(authSaga),
            fork(dashboardSaga),
            fork(clientSaga),
            fork(featureSaga),
            fork(ownerSaga),
            fork(blogSaga),
            fork(popularPlaceSaga),
            fork(homepageImageSaga),
            fork(memberSaga),
            fork(propertySaga),
            fork(accountSaga)
        ])
    })
}

export const middlewares = applyMiddleware(sagaMiddleware);

export const reducers = combineReducers({
    app: AppReducer,
    auth: AuthReducer,
    dashboard: DashboardReducer,
    client: ClientReducer,
    feature: FeatureReducer,
    owner: OwnerReducer,
    blog: BlogReducer,
    popularPlace: PopularPlaceReducer,
    homepageImage: HomepageImageReducer,
    member: MemberReducer,
    property: PropertyReducer,
    account: AccountReducer
})

export function* resetToInitialState() {
    yield* put(appActions.resetToInitialState());
    yield* put(authActions.resetToInitialState());
    yield* put(dashboardActions.resetToInitialState());
    yield* put(clientActions.resetToInitialState());
    yield* put(featureActions.resetToInitialState());
    yield* put(ownerActions.resetToInitialState());
    yield* put(blogActions.resetToInitialState());
    yield* put(popularPlaceActions.resetToInitialState());
    yield* put(homepageImageActions.resetToInitialState());
    yield* put(memberActions.resetToInitialState());
    yield* put(propertyActions.resetToInitialState());
    yield* put(accountActions.resetToInitialState());
}
